/**
 * stageOfferAdapter — `stage_offer` de `UserSubscriptionResource` → `UIParentStageOffer`.
 *
 * Le backend décide de tout (`App\Services\Course\ParentStageOffer`) : le bloc est nul quand il
 * n'y a rien à proposer à cet élève. Ici, on n'écrit que les dates.
 */
import { formatDateRange } from "../../../ui/formatters/dateFormatter"
import { type UIParentStageOffer } from "../../../ui/types"

/**
 * `stage_offer` — `App\Services\Course\ParentStageOffer`. Le backend sert tout ou rien ; les champs
 * restent optionnels ici, parce qu'un type ne valide rien à l'exécution et qu'une app installée
 * lit le backend du jour.
 */
export type ApiStageOffer = {
    offer_id?: number | null
    label?: string | null
    stage_slug?: string | null
    /** Le premier départ encore achetable, `YYYY-MM-DD`. */
    starts_on?: string | null
    /** La fin du dernier départ achetable, `YYYY-MM-DD`. */
    ends_on?: string | null
    url?: string | null
}

/** Rien sans destination ni dates : une carte dont le bouton ne mène nulle part est un cul-de-sac. */
export function toUIParentStageOffer(block: ApiStageOffer | null | undefined): UIParentStageOffer | null {
    if (block?.offer_id == null || !block.url || !block.label || !block.starts_on || !block.ends_on) return null
    return {
        offerId: block.offer_id,
        stageSlug: block.stage_slug ?? "",
        title: block.label,
        datesLabel: formatDateRange(block.starts_on, block.ends_on),
        url: block.url,
    }
}
